import { render, staticRenderFns } from "./OverviewTagSelector.vue?vue&type=template&id=17a11f82&scoped=true"
import script from "./OverviewTagSelector.vue?vue&type=script&lang=js"
export * from "./OverviewTagSelector.vue?vue&type=script&lang=js"
import style0 from "./OverviewTagSelector.vue?vue&type=style&index=0&id=17a11f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a11f82",
  null
  
)

export default component.exports